// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__28Hqe","imageUploader":"EGiftCard_imageUploader__2Ejj4"};